<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{snackbar_message}}</span>
      </v-snackbar>
      <v-card class="neu-glow pb-3">
        <v-card-title primary-title>
          <div class="text-h5">Sub Accounts</div>
          <v-spacer></v-spacer>
          <v-div>
            <!--
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :disabled="allUsers_hash==JSON.stringify(closedPeriods)"  :loading="loading_update" @click.stop="saveItems()">
                  <v-icon color="error">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            -->             
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  :loading="loading_update" @click.stop="editItem(null)">
                  <v-icon color="info">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Aggiungi</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                           
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  :loading="loading_update" @click.stop="getData('refresh')">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-div>           
        </v-card-title>
        <div class="mx-4">
          <v-data-table
            dense
            fixed-header
            :headers="headers"
            :items="!allUsers?[]:allUsers"
            hide-default-footer
            :items-per-page=500
            item-class="row-height-36"
            :loading="loading||loading_refresh"		   
            no-data-text="Nessun dato presente in archivio"
            no-results-text="Nessun Risultato estratto"
            loading-text="Consultazione archivio: attendi..."
          >

            <template v-slot:[`item.username`]="{ item }">
                <v-text-field
                  :readonly="item&&!item.editable"
                  v-model="item.username"
                  label="UserName"
                  name="username"
                  :id="item.userid"
                  prepend-inner-icon="mdi-account"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  @input.native="save"
                  class="py-2"
                  hide-details
                ></v-text-field>   
            </template>

            <template v-slot:[`item.email`]="{ item }">
                <v-text-field
                  v-model="item.email"
                  :readonly="item&&!item.editable"
                  label="Email"
                  name="email"
                  :id="item.userid"
                  prepend-inner-icon="mdi-email"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  @input.native="save"
                  hide-details
                  class="py-2"
                ></v-text-field>   
            </template>   

            <template v-slot:[`item.privileges`]="{ item }">
              <v-btn 
                @click="dialog_modules_privileges_open(item)"
                :disabled="!item.editable"
              >
                {{item.privileges}}
              </v-btn>   
            </template>

            <template v-slot:[`item.token`]="{ item }">
              <v-btn 
                @click="dialog_showToken_open(item)"
                :disabled="!item.editable"
              >
                Token
              </v-btn>   
            </template>            

            <template v-slot:[`item.settingsPrivileges`]="{ item }">
              <v-btn 
                @click="dialog_settings_privileges_open(item)"
                :disabled="!item.editable"
              >
                {{item.settingsPrivileges}}
              </v-btn>   
            </template>                     
            
            <template v-slot:[`item.active`]="{ item }">
              <v-simple-checkbox
                :disabled="!item.editable"
                v-model="item.active"
                @click="save2(item.active,'active',item.userid)"
                color="info"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.landingPage`]="{ item }">
                <v-select
                  v-model="item.landingPage"
                  :readonly="item&&!item.editable"
                  :items="allModules"
                  item-text="name"
                  item-value="moduleId"                  
                  label="Landing Page"
                  prepend-inner-icon="mdi-map-marker"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  class="py-2"
                  hide-details
                  @change="save2(item.landingPage,'landingPage',item.userid)"
                ></v-select>                   
            </template>
          

            <template v-slot:[`item.actions`]="{ item }">
              <template v-if="item.editable">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs" v-on="on" 
                      color="error"
                      class="mr-2"
                      @click="deleteItem(item)"
                      >
                      mdi-delete
                    </v-icon>                     
                  </template>
                  <span>Elimina</span>
                </v-tooltip>                                 
              </template>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs" v-on="on" 
                    color="info"
                    class="mr-2"
                    :disabled='!item.email'
                    @click="sendItem(item)"
                    >
                    mdi-send
                  </v-icon>                     
                </template>
                <span>Invia email</span>
              </v-tooltip>  

            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-form>
    
    <v-dialog v-model="dialog_edit" 
        max-width="600"
        v-if="dialog_edit"
      >
        <v-card class="neu-glow">
          <v-card-title>
            {{editedItem.username?'Modifica':'Inserisci'}} SubAccount
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :disabled="editedItem_hash==JSON.stringify(editedItem)" :loading="loading_update" @click="saveItem()">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialog_edit=false" fab small class="neu-glow" v-bind="attrs" v-on="on">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row class="pt-3 mb-0">
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.username"
                  label="UserName"
                  prepend-inner-icon="mdi-user"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  hide-detail
                ></v-text-field>              
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.email"
                  label="Email"
                  prepend-inner-icon="mdi-email"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  hide-detail
                ></v-text-field>
              </v-col>          
              <v-col cols="6">
                <v-select
                  v-model="editedItem.landingPage"
                  :items="allModules"
                  item-text="name"
                  item-value="moduleId"                  
                  label="Landing Page"
                  prepend-inner-icon="mdi-map-marker"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  class="py-2"
                  hide-details
                ></v-select>             
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-switch
                    v-model="editedItem.active"
                    inset
                    :label="editedItem.active?'Attivo':'Non Attivo'"
                ></v-switch>
              </v-col>
            </v-row>         
          </v-card-text>
        </v-card>
    </v-dialog>
        
    <v-dialog v-model="dialog_modules_privileges" persistent max-width="1200" v-if="allModules&&activeUser">
        <v-card class="neu-glow pb-1">
            <v-card-title class="text-h5 mb-3"
            >
              Privilegi Moduli: {{modulesPrivileges}}
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="save2(modulesPrivileges,'privileges',activeUser.userid)">
                      <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                  </template>
                  <span>Salva</span>
              </v-tooltip> 
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_modules_privileges = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>                             
            </v-card-title>
            <v-divider></v-divider>              
            <v-row class="mx-5 mb-1 py-3">
                <v-col cols="12">
                  <div class="pb-2 mb-2">Abilita i privilegi per l'utente <span class="info--text">{{activeUser.username}}</span></div>
                  <v-card class="neu-glow px-8 pt-8">
                    <v-row  v-for="(m,i) in allModules" :key="i">
                      <v-col cols="1" class="text-center py-0 " >
                        <v-icon :color="m.iconColor" v-bind="attrs" v-on="on">{{m.icon}}</v-icon>
                      </v-col>
                      <v-col cols="1" class="text-center py-0" >
                        <v-checkbox
                          @change="isSet => modulesPrivileges = isSet ? (modulesPrivileges | m.privileges) : (modulesPrivileges & ~m.privileges)"
                          :input-value="(m.privileges & modulesPrivileges)!=0"
                          class="mt-0 pl-6"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="10" class="pt-1">
                        <div v-html="m.name+ ' - ' +m.description"></div>
                      </v-col>
                    </v-row>                    

                  </v-card>
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_settings_privileges" persistent max-width="1200" v-if="allSettings&&activeUser">
        <v-card class="neu-glow pb-1">
            <v-card-title class="text-h5 mb-3"
            >
              Privilegi Impostazioni: {{settingsPrivileges}}
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="save2(settingsPrivileges,'settingsPrivileges',activeUser.userid)">
                      <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                  </template>
                  <span>Salva</span>
              </v-tooltip>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_settings_privileges = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>                              
            </v-card-title>
            <v-divider></v-divider>              
            <v-row class="mx-5 mb-1 py-3">
                <v-col cols="12">
                  <div class="pb-2 mb-2">Abilita i privilegi per l'utente <span class="info--text">{{activeUser.username}}</span></div>
                  <v-card class="neu-glow px-8 pt-8">
                    <v-row>
                      <template v-for="(s,i) in allSettings">
                        <v-col cols="1" class="text-left py-0" :key="i">
                          <v-checkbox
                            @change="isSet => settingsPrivileges = isSet ? (settingsPrivileges | s.privileges) : (settingsPrivileges & ~s.privileges)"
                            :input-value="(s.privileges & settingsPrivileges)!=0"
                            class="mt-0 float-right"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="5" class="pt-1" :key="i">
                          <div v-html="s.title+ ' - ' +s.description"></div>
                          <!--<div>{{s.title+ ' - ' +s.description}} {{settingsPrivileges+' && '+s.privileges  + '='+ calc(settingsPrivileges,s.privileges)}}</div>-->
                        </v-col>
                      </template>
                    </v-row>
                  </v-card>
            </v-row>
        </v-card>
    </v-dialog> 
    <v-dialog v-model="dialog_showToken" max-width="800" v-if="allSettings&&activeUser">
        <v-card class="neu-glow pb-1">
            <v-card-title class="text-h5 mb-3">
              Token Accesso Rapido per  <span class="info--text ml-3">{{activeUser.username}}</span>
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_showToken= false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>                              
            </v-card-title>
            <v-divider></v-divider>              
            <v-row class="mx-5 mb-1 py-3">
              <v-col cols="10">
                <div class="pb-2 mb-2">Token di Accesso per l'utente</div>
                <v-card class="neu-glow px-8 pt-4">
                  <v-row>
                    <v-col>
                      {{activeUser.token}}
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="2" class="d-flex align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="copyToClipboard(activeUser.token)" fab small class="neu-glow mr-4 d-flex align-center justify-center" v-bind="attrs" v-on="on">
                      <v-icon color="warning">mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copia negli Appunti</span>
                </v-tooltip>
              </v-col>
              <v-col cols="10">
                <div class="pb-2 mb-2">URL di Accesso rapido</div>
                <v-card class="neu-glow px-8 pt-4">
                  <v-row>
                    <v-col>
                      {{'https://ibookrestaurant.com/auth/login/?token='+activeUser.token}}
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="2" class="d-flex align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="copyToClipboard('https://ibookrestaurant.com/auth/login/?token='+activeUser.token)" fab small class="neu-glow mr-4 d-flex align-center justify-center" v-bind="attrs" v-on="on">
                      <v-icon color="warning">mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copia negli Appunti</span>
                </v-tooltip>
              </v-col>
            </v-row>
        </v-card>
    </v-dialog>        
    <v-dialog v-model="dialog_delete" max-width="600px">
        <v-card>
            <v-card-title class="text-h5">
              Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="saveItem('delete')">
                      <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                  </template>
                  <span>Conferma</span>
              </v-tooltip>  
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
        </v-card>
    </v-dialog>      
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from 'lodash'
export default {
  data() {
    return {
      page: "Account",
      form: null,   
      message:'',
      allUsers:null,
      allModules:null,
      allSettings:null,
      modulesPrivileges:null,
      settingsPrivileges:null,
      one:1,
      activeUser:null,
      snackbar: false,  
      snackbar_color:'success',
      snackbar_message:null,
      levels:[{"text":"Addetto: Solo Consultazione Manage","value":10},{"text":"Cucina: Solo Consultazione Arrivi","value":40},{"text":"Manager: Gestione Prenotazioni e Impostazioni","value":50},{"text":"Admin: Accesso Completo","value":100}], 
      emptyEditedItem:{username:"",email:"",active:1,level:1,landingPage:""},
      dialog_edit:false,
      dialog_delete:false,
      dialog_closedDayException:false,
      dialog_instruction:false,
      dialog_modules_privileges:false,
      dialog_settings_privileges:false,
      dialog_showToken:false,
      closedPeriods:[],
      headers: [
          { text: 'UserName',     value: 'username',            align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Email',        value: 'email',               align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Token',        value: 'token',               align: 'center',  sortable: false, class:'text-lg-button' },
          //{ text: 'Landing Page', value: 'landingPage',         align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Moduli',       value: 'privileges',          align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Impostazioni', value: 'settingsPrivileges',  align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Attivo',       value: 'active',              align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Azione',       value: 'actions',             align: 'center',  sortable: false, class:'text-lg-button' },
      ],
      editedItem:null,
      allUsers_hash:null,
      editedItem_hash:null,

    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
    copyToClipboard(txt)
    {
      navigator.clipboard.writeText(txt);
      this.snackbar_color="success"
      this.snackbar_message ='Copiato negli Appunti';
      this.snackbar = true;
    },    
    save: _.debounce(function (event) {
      console.log(400,event,event.target.name,event.target.value)
      var v=event.target.value;
      var value=v===false?0:v===true?1:v===''?null:v;
      var userid=event.target.id;
      var pload={"field":event.target.name,"value":value,"userid":userid};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"Users","payload":pload};
      console.log(406,payload)
      this.updateDB(payload)
    }, 1000),

    save2(value, field,userid) {
      console.log(410,value, field,userid);
      var pload={"field":field,"userid":userid,"value":value===false?0:value===true?1:value===''?null:value};
      var action='saveItem';
      let payload={"action":action,"table":"Users","payload":pload};
      console.log(413,payload)
      this.updateDB(payload)
    },

    /*
    async savePrivileges(typ)
    {
      this.dialog_settings_privileges = false;
      this.dialog_modules_privileges=false;
      console.log(239,this.activeUser);
      
      if(typ=='settings')
      {
        this.activeUser.settingsPrivileges=this.settingsPrivileges;
      }
      else
      {
        this.activeUser.privileges=this.modulesPrivileges;
      }
      console.log(239,this.activeUser);
      this.loading_update=true;
      let payload={"action":"savePrivileges","table":"Users","payload":[this.activeUser]};
      console.log(253,payload)
      let w= await this.updateDB(payload)
      this.loading_update=false;
      this.dialog_delete=false;
      console.log(256,w);
      if(w.errorid=='0')
      {
          this.snackbar_color="success"
          this.snackbar_message =w.message;
          this.snackbar = true;
          this.dialog_edit=false;
          this.getData()
          this.editedItem_hash=JSON.stringify(this.editedItem);
      } 
    },
    calc(s,v)
    {
      return (v&s)>0;
    },
    */

    dialog_modules_privileges_open(item)
    {
      console.log(424,item.privileges)
      this.activeUser=item;
      this.modulesPrivileges=item.privileges;
      console.log(426,this.modulesPrivileges)
      this.dialog_modules_privileges=true;
    },

    dialog_showToken_open(item)
    {
      console.log(424,item.privileges)
      this.activeUser=item;
      this.dialog_showToken=true;
    },

    dialog_settings_privileges_open(item)
    {
      this.activeUser=item;
      console.log(431,item.settingsPrivileges)
      this.settingsPrivileges=item.settingsPrivileges;
      console.log(433,this.settingsPrivileges)
      this.dialog_settings_privileges=true;
    },

    async sendItem(f)
    {
      console.log(463,f,this.editedItem)
      this.loading_update=true;
      console.log(241,this.form);
      var action='sendMailToUser';
      let payload={"action":action,"table":"Users","payload":f};
      console.log(253,payload)
      let w= await this.updateDB(payload)
      console.log(w);
    },
    editItem(f)
    {
      this.editedItem=f?f:{...this.emptyEditedItem};
      console.log(214,f,this.editedItem)
      this.editedItem_hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteItem(i)
    {
      this.editedItem=i;
      console.log(359,i,this.editedItem)
      this.dialog_delete=true;
    },
    
    async saveItem(a)
    {
        console.log(239,this.editedItem);
        this.loading_update=true;
        console.log(241,this.form);
        var editedItem=this.editedItem;
        var action=a=='delete'?'deleteItem':'saveItem';
        editedItem.field=action;
        let payload={"action":action,"table":"Users","payload":editedItem};
        console.log(253,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.dialog_delete=false;
        console.log(256,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.snackbar_message =w.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.getData()
            this.editedItem_hash=JSON.stringify(this.editedItem);
        }   
    },    /*
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        let payload={"action":"saveItem","table":"Users","payload":JSON.stringify(this.allUsers)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.getData();
            this.allUsers_hash=JSON.stringify(this.allUsers);
        }   
    },  */   
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"allUsers_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.allUsers=res.data.payloads.allUsers;
                    this.allModules=res.data.payloads.allModules;
                    this.allSettings=res.data.payloads.allSettings;
                    this.allUsers_hash=JSON.stringify(this.allUsers);  
                    console.log(315,this.allUsers)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            this.dialog_settings_privileges=false;
            this.dialog_modules_privileges=false
            this.loading_update=false;
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
            if (res.data.message)
            {
                console.log(572);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(342);
              //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style>
  .v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td, .row-height-36
  {
    height: 34px !important;
  }
  #quill-container{height:200px!important}
</style>